import React, { useContext } from 'react'
import style from './Next.module.scss'

import MarkdownDataContext from '~contexts/MarkdownDataContext'
import { Link } from 'gatsby'

const Next = ({
  children
}) => {
  const data = useContext(MarkdownDataContext)

  return (
    <>
      { data.nextPage && (
        <div className={style.next}>
          <Link to={ data.nextPage.path }>
            { children }
          </Link>
        </div>
      )}
    </>
  )
}

export default Next